import React from 'react';
import { string, func } from 'prop-types';
import { Card, CardTitle } from '@one-thd/sui-atomic-components';

/*
NOTE: This subcomponent is only being used temporarily as the functionality is still being
developed for PromotionProducts. This should be deleted once PromotionProducts supports the
props `onFail` and `customerId`
*/
const PromotionProductsMock = ({ onFail, type, customerId }) => {
  if (!customerId) {
    onFail();
  }

  return (
    <Card>
      <CardTitle header="Buy One, Get One Free" eyebrow="Ends Jan 18" />
      PromotionProducts Mock <br />
      Anchor Item Here <br />
      BOGO Item Here <br />
    </Card>
  );
};

PromotionProductsMock.propTypes = {
  onFail: func,
  type: string,
  customerId: string
};

PromotionProductsMock.defaultProps = {
  onFail: null,
  type: null,
  customerId: null
};

export { PromotionProductsMock };
